import { AsyncThunkConfig } from '@/store/actions'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  TakeSnapshotBeneficiaryOptions,
  TakeSnapshotOrganizationOptions,
} from '@repo/shared/dtos/snapshot'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { toast } from 'sonner'

export const snapshot = {
  //
  // SUDO
  //
  sudo: {
    takeSnapshot: createAsyncThunk<
      { snapshotId: string; snapshotData: string },
      {
        organizationId: string
        organizationOptions: TakeSnapshotOrganizationOptions
        beneficiaryOptions: TakeSnapshotBeneficiaryOptions
        onlyBeneficiaryIds?: string[]
      },
      AsyncThunkConfig
    >('TAKE_SNAPSHOT', async (payload, { extra, rejectWithValue }) => {
      const { sudoApi } = extra
      const res = await sudoApi.snapshot.takeSnapshot(payload)
      if (hasError(res)) return rejectWithValue(handleError(res))

      //fixme something 'smarter' ?
      const dateShort = new Date()
        .toISOString()
        .slice(0, 19)
        .replaceAll('_', '')
        .replaceAll(':', '')
        .replaceAll('-', '')
      const url = URL.createObjectURL(
        new Blob([res.snapshotData ?? '<no data>'], {
          type: 'application/json;charset=utf-8',
        }),
      )
      const fileName = `org-${payload.organizationId}.date-${dateShort}.snapshot-${res.snapshotId}.json`
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
      URL.revokeObjectURL(url)

      toast.info(`Snapshot created and downloaded - file : ${fileName}`)
      return res
    }),
  },
}
